import "./DashboardHeader.css"

import { Link, useLocation } from 'react-router-dom'
import {useDashboardLocale} from "../../context/dashboard_locale";

export default function DashboardHeader() {
    const {strings} = useDashboardLocale()
    const links = [
        {
            title: strings["list"],
            link: "/dashboard/exhibitions",
        },
        {
            title: strings["create"],
            link: "/dashboard/create",
        },
        {
            title: strings["settings"],
            link: "/dashboard/settings",
        },
    ]
    const location = useLocation()

    return (
        <header className="p-6 bg-primary-500 text-gray-100">
            <div className="container mx-auto px-2 flex justify-between items-center">
                <div className="flex items-center gap-1">
                    <svg className="block fill-current h-8 w-8 mr-2" width="54" height="54" viewBox="0 0 54 54"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M13.5 22.1c1.8-7.2 6.3-10.8 13.5-10.8 10.8 0 12.15 8.1 17.55 9.45 3.6.9 6.75-.45 9.45-4.05-1.8 7.2-6.3 10.8-13.5 10.8-10.8 0-12.15-8.1-17.55-9.45-3.6-.9-6.75.45-9.45 4.05zM0 38.3c1.8-7.2 6.3-10.8 13.5-10.8 10.8 0 12.15 8.1 17.55 9.45 3.6.9 6.75-.45 9.45-4.05-1.8 7.2-6.3 10.8-13.5 10.8-10.8 0-12.15-8.1-17.55-9.45-3.6-.9-6.75.45-9.45 4.05z"
                        />
                    </svg>
                    <Link className="text-lg font-normal hover:text-gray-300" to="/dashboard/exhibitions">{strings["dashboard"]}</Link>
                </div>

                <ul className="flex items-center gap-8 font-light">
                    { links.map((item,index) => {
                        let className = "cursor-pointer text-lg hover:text-gray-300"
                        if (!location.pathname.localeCompare(item.link)) {
                            className = [className, "font-medium"].join(" ")
                        }
                        return (
                            <li key={index}><Link to={item.link} className={className}>{item.title}</Link></li>
                        )
                    })
                    }
                </ul>
            </div>
        </header>
    )
}